import { channelSlice } from "./channel.reducer";

export const {
  updateChannelInput,
  setCurrentProject,
  setCurrentChannel,
  setCurrentChannelVideo,
} = channelSlice.actions;
export default channelSlice.actions;
